import { render } from "./BaseQuote.vue?vue&type=template&id=d754aad6"
import script from "./BaseQuote.vue?vue&type=script&lang=js"
export * from "./BaseQuote.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__